import urljoin from "url-join";

const ROOT = "/";

export const APP_ROUTES = {
  ROOT: "",
  CALLBACK: "sign-callback",
  CALLBACK_MOBILE: "sign-callback-mobile-app",
  REDIRECT_TO_APP: "redirect-to-app",
  LOGOUT_APP: "log-out-app",
  AUTH: "auth",
  MULTITENANT_ACCESS: "multitenant-access",
  HOME: "home",
  DIMENSIONS: "dimensions",
  DIMENSION_ASSIGNMENT: "dimension-assignment",
  CUSTOMER_ORDERS: "customer-orders",
  CUSTOMERS: "customers",
  ADMINISTRATION: "administration",
  NO_ACCESS: "no-access",
  VIEW_PDF: "view-pdf",
  PROFILE: "profile",
  DASHBOARD: "hub-dashboard",
  REPORTS: "reports",
  CHART_VIEW: "chart-view",
  HELP: "help",
  QUICK_SEARCH: "quick-search",
  MANAGE_PAGE: "manage",
  OPERATIONS_PAGE: "operations",
};

export const CRUD_ROUTES = {
  LIST: "",
  ADD: "add",
  DETAILS: ":id",
};

export const AUTH_ROUTES = {
  LOGIN: "",
};

export const CUSTOMER_ORDERS_ROUTES = {
  CUSTOMER_ORDERS: "customer-orders",
  CREDITS: "credits",
  DELIVERED_SHELF_LIFE: "delivered-shelf-life",
};

export const DASHBOARD_ROUTES = {
  CUSTOMER_ORDERS: "customer-orders",
  PRODUCTS_AVAILABILITY: "products-availability",
  INVENTORY_BY_SITE: "inventory-by-site",
  SHELF_LIFE_BY_SITE: "shelf-life-by-site",
  GEO_LOCATIONS: "geo-locations",
};

export const DIMENSIONS_ROUTES = {
  DIMENSION_TYPE: "type",
};

export const OPERATIONS_ROUTES = {
  INVENTORY_TRANSACTIONS: "inventory-transactions",
  RECEIVING: "receiving",
  PICKING: "picking",
  WORK_ORDER: "work-order",
  RETURNS: "returns",
  ESTIMATED_SALES: "estimated-sales",
  SHELF_LIFE: "shelf-life",
  TRANSFER_INVENTORY: "transfer-inventory",
  CONVERSION: "conversion",
};

export const ADMINISTRATION_ROUTES = {
  ROLES: "roles",
  PERMISSIONS: "permissions",
  USERS: "users",
  LOCATIONS: "locations",
  DOCUMENTS: "documents",
  APPLICATIONS: "applications",
  USERS_SETTINGS: "users-settings",
};
export const LOCATION_TABS = {
  GENERAL: "general",
  SALES_SETUP: "sales-setup",
  INVENTORY_CONTROL: "inventory-control",
  SITES: "sites",
  SCAN_DOCUMENTS: "scan-documents",
  LABEL_SETTINGS: "label-settings",
};
export const INVENTORY_CONTROL_TABS = {
  SETTINGS: "settings",
  ITEMS: "items",
  NATIONAL_ACCOUNTS: "national-accounts",
  INTERNAL_TRANSFERS: "internal-transfers",
  EXTERNAL_UPC: "external-upc",
};

export const MANAGE_ROUTES = {
  CUSTOMER_ORDERS: "customer-orders",
  PRINTER_DEVICE_ASSIGNMENT: "printer-device-assignment",
  BARCODE_TESTER: "barcode-tester",
  EXTERNAL_UPC: "external-upc",
  INVENTORY_COUNTING: "inventory-counting",
  COUNT_INVENTORY: "count-inventory",
  ITEM_SETTINGS: "item-settings",
  SCAN_DOCUMENTS: "scan-documents",
  PRICE_LIST: "price-list",
  SITES: "sites",
  PRODUCT_REPOSITORY: "products-repository",
  LABEL_TEMPLATES: "label-templates",
  OCR_TESTER: "ocr-tester",
  TASK_PROCESS: "task-process",
  LABEL_PRINTING: "label-printing",
  TRACEABILITY_CONTROL: "traceability-control",
};

export const HELP_ROUTES = {
  MANAGE_HELP: "manage-help",
  GUIDES_RESOURCES: "guides-resources",
  HELP_SUPPORT: "help-support",
};

export const MANAGE_HELP_ROUTES = {
  HELP_CATEGORIES: "categories",
  HELP_POSTS: "posts",
};

export const QUICK_SEARCH_ROUTES = {
  PRODUCTS: "products",
  CUSTOMERS: "customers",
};

export const ROUTE_PATHS = {
  CALLBACK_PAGE: [ROOT, APP_ROUTES.CALLBACK],
  CALLBACK_MOBILE_PAGE: [ROOT, APP_ROUTES.CALLBACK_MOBILE],
  REDIRECT_TO_APP_PAGE: [ROOT, APP_ROUTES.REDIRECT_TO_APP],
  HOME_PAGE: [ROOT, APP_ROUTES.HOME],

  // AUTH_ROUTES
  LOGIN_PAGE: [ROOT, APP_ROUTES.AUTH, AUTH_ROUTES.LOGIN],
  MULTITENANT_ACCESS_PAGE: [
    ROOT,
    APP_ROUTES.MULTITENANT_ACCESS,
    CRUD_ROUTES.LIST,
  ],

  // Dimensions Routes
  DIMENSIONS_LIST_PAGE: [ROOT, APP_ROUTES.DIMENSIONS],
  DIMENSIONS_TYPE_LIST_PAGE: (id: string) => [ROOT, APP_ROUTES.DIMENSIONS, id],

  // Dimension assignment Routes
  DIMENSION_ASSIGNMENT_PAGE: (id: string) => [
    ROOT,
    APP_ROUTES.DIMENSION_ASSIGNMENT,
    id,
  ],

  // CUSTOMER_ORDERS_CO_LIST_PAGE
  CUSTOMER_ORDERS_MAIN_PAGE: [ROOT, APP_ROUTES.CUSTOMER_ORDERS],
  CUSTOMER_ORDERS_CO_LIST_PAGE: [
    ROOT,
    APP_ROUTES.CUSTOMER_ORDERS,
    CUSTOMER_ORDERS_ROUTES.CUSTOMER_ORDERS,
  ],
  CUSTOMER_ORDERS_CO_DETAIL_PAGE: (id: string) => [
    ROOT,
    APP_ROUTES.CUSTOMER_ORDERS,
    CUSTOMER_ORDERS_ROUTES.CUSTOMER_ORDERS,
    id,
  ],
  CUSTOMER_ORDERS_CREDITS_LIST_PAGE: [
    ROOT,
    APP_ROUTES.CUSTOMER_ORDERS,
    CUSTOMER_ORDERS_ROUTES.CREDITS,
  ],
  CUSTOMER_ORDERS_CREDITS_DETAIL_PAGE: (id: string) => [
    ROOT,
    APP_ROUTES.CUSTOMER_ORDERS,
    CUSTOMER_ORDERS_ROUTES.CREDITS,
    id,
  ],
  CUSTOMER_ORDERS_DELIVERED_SHELF_LIFE_PAGE: [
    ROOT,
    APP_ROUTES.CUSTOMER_ORDERS,
    CUSTOMER_ORDERS_ROUTES.DELIVERED_SHELF_LIFE,
  ],

  // ADMINISTRATION
  ADMINISTRATION: [ROOT, APP_ROUTES.ADMINISTRATION],
  ADMINISTRATION_ROLES_LIST_PAGE: [
    ROOT,
    APP_ROUTES.ADMINISTRATION,
    ADMINISTRATION_ROUTES.ROLES,
  ],
  ADMINISTRATION_PERMISSIONS_LIST_PAGE: [
    ROOT,
    APP_ROUTES.ADMINISTRATION,
    ADMINISTRATION_ROUTES.PERMISSIONS,
  ],
  ADMINISTRATION_USERS_LIST_PAGE: [
    ROOT,
    APP_ROUTES.ADMINISTRATION,
    ADMINISTRATION_ROUTES.USERS,
  ],
  ADMINISTRATION_LOCATIONS_LIST_PAGE: [
    ROOT,
    APP_ROUTES.ADMINISTRATION,
    ADMINISTRATION_ROUTES.LOCATIONS,
  ],
  ADMINISTRATION_LOCATIONS_DETAILS_PAGE: (id: string) => [
    ROOT,
    APP_ROUTES.ADMINISTRATION,
    ADMINISTRATION_ROUTES.LOCATIONS,
    id,
  ],
  ADMINISTRATION_LOCATIONS_DETAILS_TAB_PAGE: (id: string, ...tabs: string[]) => [
    ROOT,
    APP_ROUTES.ADMINISTRATION,
    ADMINISTRATION_ROUTES.LOCATIONS,
    id,
    ...tabs,
  ],
  ADMINISTRATION_DOCUMENTS_LIST_PAGE: [
    ROOT,
    APP_ROUTES.ADMINISTRATION,
    ADMINISTRATION_ROUTES.DOCUMENTS,
  ],
  ADMINISTRATION_APPLICATIONS_LIST_PAGE: [
    ROOT,
    APP_ROUTES.ADMINISTRATION,
    ADMINISTRATION_ROUTES.APPLICATIONS,
  ],
  ADMINISTRATION_USERS_SETTINGS_PAGE: [
    ROOT,
    APP_ROUTES.ADMINISTRATION,
    ADMINISTRATION_ROUTES.USERS_SETTINGS,
  ],

  DASHBOARD_PAGE: [ROOT, APP_ROUTES.DASHBOARD],
  DASHBOARD_CUSTOMER_ORDERS_PAGE: [
    ROOT,
    APP_ROUTES.DASHBOARD,
    DASHBOARD_ROUTES.CUSTOMER_ORDERS,
  ],
  DASHBOARD_PRODUCTS_AVAILABILITY_PAGE: [
    ROOT,
    APP_ROUTES.DASHBOARD,
    DASHBOARD_ROUTES.PRODUCTS_AVAILABILITY,
  ],
  DASHBOARD_INVENTORY_BY_SITE_PAGE: [
    ROOT,
    APP_ROUTES.DASHBOARD,
    DASHBOARD_ROUTES.INVENTORY_BY_SITE,
  ],
  DASHBOARD_SHELF_LIFE_BY_SITE_PAGE: [
    ROOT,
    APP_ROUTES.DASHBOARD,
    DASHBOARD_ROUTES.SHELF_LIFE_BY_SITE,
  ],
  DASHBOARD_GEO_LOCATIONS_PAGE: [
    ROOT,
    APP_ROUTES.DASHBOARD,
    DASHBOARD_ROUTES.GEO_LOCATIONS,
  ],

  // view pdf
  VIEW_PDF_PAGE: (id: string) => [ROOT, APP_ROUTES.VIEW_PDF, id],

  // reports routes
  REPORTS_PAGE: [ROOT, APP_ROUTES.REPORTS],

  // chart-view routes
  CHART_VIEW_PAGE: [ROOT, APP_ROUTES.CHART_VIEW],

  // help routes
  HELP_PAGE: [ROOT, APP_ROUTES.HELP],
  MANAGE_HELP_PAGE: [ROOT, APP_ROUTES.HELP, HELP_ROUTES.MANAGE_HELP],
  GUIDES_RESOURCES_PAGE: [ROOT, APP_ROUTES.HELP, HELP_ROUTES.GUIDES_RESOURCES],
  HELP_SUPPORT_PAGE: [ROOT, APP_ROUTES.HELP, HELP_ROUTES.HELP_SUPPORT],
  HELP_CATEGORIES_PAGE: [
    ROOT,
    APP_ROUTES.HELP,
    HELP_ROUTES.MANAGE_HELP,
    MANAGE_HELP_ROUTES.HELP_CATEGORIES,
  ],
  HELP_POSTS_PAGE: [
    ROOT,
    APP_ROUTES.HELP,
    HELP_ROUTES.MANAGE_HELP,
    MANAGE_HELP_ROUTES.HELP_POSTS,
  ],
  HELP_POSTS_DETAIL_PAGE: (id: string) => [
    ROOT,
    APP_ROUTES.HELP,
    HELP_ROUTES.MANAGE_HELP,
    MANAGE_HELP_ROUTES.HELP_POSTS,
    id,
  ],
  GUIDES_RESOURCES_TOPIC_DETAIL_PAGE: (id: string) => [
    ROOT,
    APP_ROUTES.HELP,
    HELP_ROUTES.GUIDES_RESOURCES,
    id,
  ],

  // QUICK_SEARCH
  QUICK_SEARCH_PAGE: [ROOT, APP_ROUTES.QUICK_SEARCH],
  PRODUCTS_QUICK_SEARCH_PAGE: [
    ROOT,
    APP_ROUTES.QUICK_SEARCH,
    QUICK_SEARCH_ROUTES.PRODUCTS,
  ],
  PRODUCTS_DETAIL_PAGE: (id: string) => [
    ROOT,
    APP_ROUTES.QUICK_SEARCH,
    QUICK_SEARCH_ROUTES.PRODUCTS,
    id,
  ],
  CUSTOMERS_QUICK_SEARCH_PAGE: [
    ROOT,
    APP_ROUTES.QUICK_SEARCH,
    QUICK_SEARCH_ROUTES.CUSTOMERS,
  ],

  // MANAGE_PAGE
  MANAGE_PAGE: [ROOT, APP_ROUTES.MANAGE_PAGE],
  MANAGE_CUSTOMER_ORDERS_PAGE: [
    ROOT,
    APP_ROUTES.MANAGE_PAGE,
    MANAGE_ROUTES.CUSTOMER_ORDERS,
  ],
  MANAGE_ITEM_SETTINGS_PAGE: [
    ROOT,
    APP_ROUTES.MANAGE_PAGE,
    MANAGE_ROUTES.ITEM_SETTINGS,
  ],
  MANAGE_SCAN_DOCUMENTS_PAGE: [
    ROOT,
    APP_ROUTES.MANAGE_PAGE,
    MANAGE_ROUTES.SCAN_DOCUMENTS,
  ],
  MANAGE_PRICE_LIST_PAGE: [
    ROOT,
    APP_ROUTES.MANAGE_PAGE,
    MANAGE_ROUTES.PRICE_LIST,
  ],
  MANAGE_TRACEABILITY_CONTROL_PAGE: [
    ROOT,
    APP_ROUTES.MANAGE_PAGE,
    MANAGE_ROUTES.TRACEABILITY_CONTROL,
  ],
  MANAGE_PRINTER_DEVICE_ASSIGNMENT_PAGE: [
    ROOT,
    APP_ROUTES.MANAGE_PAGE,
    MANAGE_ROUTES.PRINTER_DEVICE_ASSIGNMENT,
  ],

  MANAGE_BARCODE_TESTER_PAGE: [
    ROOT,
    APP_ROUTES.MANAGE_PAGE,
    MANAGE_ROUTES.BARCODE_TESTER,
  ],

  // INVENTORY_COUNTING
  MANAGE_INVENTORY_COUNTING_LIST_PAGE: [
    ROOT,
    APP_ROUTES.MANAGE_PAGE,
    MANAGE_ROUTES.INVENTORY_COUNTING,
  ],

  MANAGE_EXTERNAL_UPC_PAGE: [
    ROOT,
    APP_ROUTES.MANAGE_PAGE,
    MANAGE_ROUTES.EXTERNAL_UPC,
  ],
  MANAGE_COUNT_INVENTORY_PAGE: [
    ROOT,
    APP_ROUTES.MANAGE_PAGE,
    MANAGE_ROUTES.COUNT_INVENTORY,
  ],
  MANAGE_SITES_PAGE: [ROOT, APP_ROUTES.MANAGE_PAGE, MANAGE_ROUTES.SITES],

  PRODUCT_REPOSITORY_PAGE: [
    ROOT,
    APP_ROUTES.MANAGE_PAGE,
    MANAGE_ROUTES.PRODUCT_REPOSITORY,
  ],

  // operations routes
  OPERATIONS_PAGE: [ROOT, APP_ROUTES.OPERATIONS_PAGE],
  OPERATIONS_INVENTORY_TRANSACTIONS_PAGE: [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.INVENTORY_TRANSACTIONS,
  ],
  OPERATIONS_INVENTORY_TRANSACTIONS_DETAIL_PAGE: (id: string) => [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.INVENTORY_TRANSACTIONS,
    id,
  ],
  OPERATIONS_RECEIVING_PAGE: [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.RECEIVING,
  ],
  OPERATIONS_RECEIVING_DETAIL_PAGE: (id: string) => [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.RECEIVING,
    id,
  ],
  OPERATIONS_PICKING_PAGE: [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.PICKING,
  ],
  OPERATIONS_PICKING_DETAIL_PAGE: (id: string) => [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.PICKING,
    id,
  ],
  OPERATIONS_WORK_ORDER_PAGE: [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.WORK_ORDER,
  ],
  OPERATIONS_WORK_ORDER_DETAIL_PAGE: (id: string) => [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.WORK_ORDER,
    id,
  ],
  OPERATIONS_RETURNS_PAGE: [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.RETURNS,
  ],
  OPERATIONS_RETURNS_DETAIL_PAGE: (id: string) => [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.RETURNS,
    id,
  ],
  OPERATIONS_ESTIMATED_SALES_PAGE: [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.ESTIMATED_SALES,
  ],
  OPERATIONS_ESTIMATED_SALES_DETAIL_PAGE: (id: string) => [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.ESTIMATED_SALES,
    id,
  ],
  OPERATIONS_SHELF_LIFE_PAGE: [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.SHELF_LIFE,
  ],
  OPERATIONS_SHELF_LIFE_DETAIL_PAGE: (id: string) => [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.SHELF_LIFE,
    id,
  ],
  OPERATIONS_TRANSFER_INVENTORY_PAGE: [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.TRANSFER_INVENTORY,
  ],
  OPERATIONS_TRANSFER_INVENTORY_DETAIL_PAGE: (id: string) => [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.TRANSFER_INVENTORY,
    id,
  ],
  OPERATIONS_CONVERSION_PAGE: [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.CONVERSION,
  ],
  OPERATIONS_CONVERSION_DETAIL_PAGE: (id: string) => [
    ROOT,
    APP_ROUTES.OPERATIONS_PAGE,
    OPERATIONS_ROUTES.CONVERSION,
    id,
  ],

  // Label templates page
  LABEL_TEMPLATES_PAGE: [
    ROOT,
    APP_ROUTES.MANAGE_PAGE,
    MANAGE_ROUTES.LABEL_TEMPLATES,
  ],

  MANAGE_OCR_TESTER_PAGE: [
    ROOT,
    APP_ROUTES.MANAGE_PAGE,
    MANAGE_ROUTES.OCR_TESTER,
  ],

  MANAGE_TASK_PROCESS_PAGE: [
    ROOT,
    APP_ROUTES.MANAGE_PAGE,
    MANAGE_ROUTES.TASK_PROCESS,
  ],

  MANAGE_LABEL_PRINTING_PAGE: [
    ROOT,
    APP_ROUTES.MANAGE_PAGE,
    MANAGE_ROUTES.LABEL_PRINTING,
  ],
};

export const ROUTES = {
  CALLBACK_PAGE: urljoin(ROUTE_PATHS.CALLBACK_PAGE),
  CALLBACK_MOBILE_PAGE: urljoin(ROUTE_PATHS.CALLBACK_MOBILE_PAGE),
  REDIRECT_TO_APP_PAGE: urljoin(ROUTE_PATHS.REDIRECT_TO_APP_PAGE),
  HOME_PAGE: urljoin(ROUTE_PATHS.HOME_PAGE),

  // AUTH_ROUTES
  LOGIN_PAGE: urljoin(ROUTE_PATHS.LOGIN_PAGE),
  MULTITENANT_ACCESS_PAGE: urljoin(ROUTE_PATHS.MULTITENANT_ACCESS_PAGE),

  // Dimensions Routes
  DIMENSIONS_LIST_PAGE: urljoin(ROUTE_PATHS.DIMENSIONS_LIST_PAGE),
  DIMENSIONS_TYPE_LIST_PAGE: (id: string | number) =>
    urljoin(ROUTE_PATHS.DIMENSIONS_TYPE_LIST_PAGE(id.toString())),

  // Dimension assignment Routes
  DIMENSION_ASSIGNMENT_PAGE: (id: string | number) =>
    urljoin(ROUTE_PATHS.DIMENSION_ASSIGNMENT_PAGE(id.toString())),

  // CUSTOMER_ORDERS_CO_LIST_PAGE
  CUSTOMER_ORDERS_MAIN_PAGE: urljoin(ROUTE_PATHS.CUSTOMER_ORDERS_MAIN_PAGE),
  CUSTOMER_ORDERS_CO_LIST_PAGE: urljoin(
    ROUTE_PATHS.CUSTOMER_ORDERS_CO_LIST_PAGE,
  ),
  CUSTOMER_ORDERS_CO_DETAIL_PAGE: (id: string | number) =>
    urljoin(ROUTE_PATHS.CUSTOMER_ORDERS_CO_DETAIL_PAGE(id.toString())),
  CUSTOMER_ORDERS_CREDITS_LIST_PAGE: urljoin(
    ROUTE_PATHS.CUSTOMER_ORDERS_CREDITS_LIST_PAGE,
  ),
  CUSTOMER_ORDERS_CREDITS_DETAIL_PAGE: (id: string | number) =>
    urljoin(ROUTE_PATHS.CUSTOMER_ORDERS_CREDITS_DETAIL_PAGE(id.toString())),
  CUSTOMER_ORDERS_DELIVERED_SHELF_LIFE_PAGE: urljoin(
    ROUTE_PATHS.CUSTOMER_ORDERS_DELIVERED_SHELF_LIFE_PAGE,
  ),

  // ADMINISTRATION
  ADMINISTRATION: urljoin(ROUTE_PATHS.ADMINISTRATION),
  ADMINISTRATION_ROLES_LIST_PAGE: urljoin(
    ROUTE_PATHS.ADMINISTRATION_ROLES_LIST_PAGE,
  ),
  ADMINISTRATION_PERMISSIONS_LIST_PAGE: urljoin(
    ROUTE_PATHS.ADMINISTRATION_PERMISSIONS_LIST_PAGE,
  ),
  ADMINISTRATION_USERS_LIST_PAGE: urljoin(
    ROUTE_PATHS.ADMINISTRATION_USERS_LIST_PAGE,
  ),
  ADMINISTRATION_LOCATIONS_LIST_PAGE: urljoin(
    ROUTE_PATHS.ADMINISTRATION_LOCATIONS_LIST_PAGE,
  ),
  ADMINISTRATION_LOCATIONS_DETAILS_PAGE: (id: string | number) =>
    urljoin(ROUTE_PATHS.ADMINISTRATION_LOCATIONS_DETAILS_PAGE(id.toString())),
  ADMINISTRATION_LOCATIONS_DETAILS_TAB_PAGE: (
    id: string | number,
    ...tabs: string[]
  ) =>
    urljoin(
      ROUTE_PATHS.ADMINISTRATION_LOCATIONS_DETAILS_TAB_PAGE(
        id.toString(),
        ...tabs,
      ),
    ),
  ADMINISTRATION_DOCUMENTS_LIST_PAGE: urljoin(
    ROUTE_PATHS.ADMINISTRATION_DOCUMENTS_LIST_PAGE,
  ),
  ADMINISTRATION_APPLICATIONS_LIST_PAGE: urljoin(
    ROUTE_PATHS.ADMINISTRATION_APPLICATIONS_LIST_PAGE,
  ),
  ADMINISTRATION_USERS_SETTINGS_PAGE: urljoin(
    ROUTE_PATHS.ADMINISTRATION_USERS_SETTINGS_PAGE,
  ),

  // DASHBOARD_PAGE ROUTES
  DASHBOARD_PAGE: urljoin(ROUTE_PATHS.DASHBOARD_PAGE),
  DASHBOARD_CUSTOMER_ORDERS_PAGE: urljoin(
    ROUTE_PATHS.DASHBOARD_CUSTOMER_ORDERS_PAGE,
  ),
  DASHBOARD_PRODUCTS_AVAILABILITY_PAGE: urljoin(
    ROUTE_PATHS.DASHBOARD_PRODUCTS_AVAILABILITY_PAGE,
  ),
  DASHBOARD_INVENTORY_BY_SITE_PAGE: urljoin(
    ROUTE_PATHS.DASHBOARD_INVENTORY_BY_SITE_PAGE,
  ),
  DASHBOARD_SHELF_LIFE_BY_SITE_PAGE: urljoin(
    ROUTE_PATHS.DASHBOARD_SHELF_LIFE_BY_SITE_PAGE,
  ),
  DASHBOARD_GEO_LOCATIONS_PAGE: urljoin(
    ROUTE_PATHS.DASHBOARD_GEO_LOCATIONS_PAGE,
  ),

  // VIEW_PDF_PAGE
  VIEW_PDF_PAGE: (id: string | number) =>
    urljoin(ROUTE_PATHS.VIEW_PDF_PAGE(id.toString())),

  // REPORTS_PAGE ROUTES
  REPORTS_PAGE: urljoin(ROUTE_PATHS.REPORTS_PAGE),

  // CHART_VIEW_PAGE ROUTES
  CHART_VIEW_PAGE: urljoin(ROUTE_PATHS.CHART_VIEW_PAGE),

  // help routes
  HELP_PAGE: urljoin(ROUTE_PATHS.HELP_PAGE),
  MANAGE_HELP_PAGE: urljoin(ROUTE_PATHS.MANAGE_HELP_PAGE),
  HELP_CATEGORIES_PAGE: urljoin(ROUTE_PATHS.HELP_CATEGORIES_PAGE),
  HELP_POSTS_PAGE: urljoin(ROUTE_PATHS.HELP_POSTS_PAGE),
  HELP_POSTS_DETAIL_PAGE: (id: string | number) =>
    urljoin(ROUTE_PATHS.HELP_POSTS_DETAIL_PAGE(id.toString())),
  // guides help routes
  GUIDES_RESOURCES_PAGE: urljoin(ROUTE_PATHS.GUIDES_RESOURCES_PAGE),
  HELP_SUPPORT_PAGE: urljoin(ROUTE_PATHS.HELP_SUPPORT_PAGE),

  GUIDES_RESOURCES_TOPIC_DETAIL_PAGE: (id: string | number) =>
    urljoin(ROUTE_PATHS.GUIDES_RESOURCES_TOPIC_DETAIL_PAGE(id.toString())),

  // QUICK_SEARCH_PAGE
  QUICK_SEARCH_PAGE: urljoin(ROUTE_PATHS.QUICK_SEARCH_PAGE),
  PRODUCTS_QUICK_SEARCH_PAGE: urljoin(ROUTE_PATHS.PRODUCTS_QUICK_SEARCH_PAGE),
  PRODUCTS_DETAIL_PAGE: (id: string | number) =>
    urljoin(ROUTE_PATHS.PRODUCTS_DETAIL_PAGE(id.toString())),

  CUSTOMERS_QUICK_SEARCH_PAGE: urljoin(ROUTE_PATHS.CUSTOMERS_QUICK_SEARCH_PAGE),

  // MANAGE_PAGE
  MANAGE_PAGE: urljoin(ROUTE_PATHS.MANAGE_PAGE),
  MANAGE_CUSTOMER_ORDERS_PAGE: urljoin(ROUTE_PATHS.MANAGE_CUSTOMER_ORDERS_PAGE),

  MANAGE_ITEM_SETTINGS_PAGE: urljoin(ROUTE_PATHS.MANAGE_ITEM_SETTINGS_PAGE),
  MANAGE_SCAN_DOCUMENTS_PAGE: urljoin(ROUTE_PATHS.MANAGE_SCAN_DOCUMENTS_PAGE),

  MANAGE_PRICE_LIST_PAGE: urljoin(ROUTE_PATHS.MANAGE_PRICE_LIST_PAGE),

  MANAGE_TRACEABILITY_CONTROL_PAGE: urljoin(
    ROUTE_PATHS.MANAGE_TRACEABILITY_CONTROL_PAGE,
  ),

  MANAGE_PRINTER_DEVICE_ASSIGNMENT_PAGE: urljoin(
    ROUTE_PATHS.MANAGE_PRINTER_DEVICE_ASSIGNMENT_PAGE,
  ),

  MANAGE_BARCODE_TESTER_PAGE: urljoin(ROUTE_PATHS.MANAGE_BARCODE_TESTER_PAGE),

  // MANAGE_INVENTORY_COUNTING_LIST_PAGE
  MANAGE_INVENTORY_COUNTING_LIST_PAGE: urljoin(
    ROUTE_PATHS.MANAGE_INVENTORY_COUNTING_LIST_PAGE,
  ),
  MANAGE_COUNT_INVENTORY_PAGE: urljoin(ROUTE_PATHS.MANAGE_COUNT_INVENTORY_PAGE),
  MANAGE_SITES_PAGE: urljoin(ROUTE_PATHS.MANAGE_SITES_PAGE),

  MANAGE_EXTERNAL_UPC_PAGE: urljoin(ROUTE_PATHS.MANAGE_EXTERNAL_UPC_PAGE),

  PRODUCT_REPOSITORY_PAGE: urljoin(ROUTE_PATHS.PRODUCT_REPOSITORY_PAGE),

  // operations routes
  OPERATIONS_PAGE: urljoin(ROUTE_PATHS.OPERATIONS_PAGE),

  OPERATIONS_INVENTORY_TRANSACTIONS_PAGE: urljoin(
    ROUTE_PATHS.OPERATIONS_INVENTORY_TRANSACTIONS_PAGE,
  ),
  OPERATIONS_INVENTORY_TRANSACTIONS_DETAIL_PAGE: (id: string | number) =>
    urljoin(
      ROUTE_PATHS.OPERATIONS_INVENTORY_TRANSACTIONS_DETAIL_PAGE(id.toString()),
    ),

  OPERATIONS_RECEIVING_PAGE: urljoin(ROUTE_PATHS.OPERATIONS_RECEIVING_PAGE),
  OPERATIONS_RECEIVING_DETAIL_PAGE: (id: string | number) =>
    urljoin(ROUTE_PATHS.OPERATIONS_RECEIVING_DETAIL_PAGE(id.toString())),

  OPERATIONS_PICKING_PAGE: urljoin(ROUTE_PATHS.OPERATIONS_PICKING_PAGE),
  OPERATIONS_PICKING_DETAIL_PAGE: (id: string | number) =>
    urljoin(ROUTE_PATHS.OPERATIONS_PICKING_DETAIL_PAGE(id.toString())),

  OPERATIONS_WORK_ORDER_PAGE: urljoin(ROUTE_PATHS.OPERATIONS_WORK_ORDER_PAGE),
  OPERATIONS_WORK_ORDER_DETAIL_PAGE: (id: string | number) =>
    urljoin(ROUTE_PATHS.OPERATIONS_WORK_ORDER_DETAIL_PAGE(id.toString())),

  OPERATIONS_RETURNS_PAGE: urljoin(ROUTE_PATHS.OPERATIONS_RETURNS_PAGE),
  OPERATIONS_RETURNS_DETAIL_PAGE: (id: string | number) =>
    urljoin(ROUTE_PATHS.OPERATIONS_RETURNS_DETAIL_PAGE(id.toString())),

  OPERATIONS_ESTIMATED_SALES_PAGE: urljoin(
    ROUTE_PATHS.OPERATIONS_ESTIMATED_SALES_PAGE,
  ),
  OPERATIONS_ESTIMATED_SALES_DETAIL_PAGE: (id: string | number) =>
    urljoin(ROUTE_PATHS.OPERATIONS_ESTIMATED_SALES_DETAIL_PAGE(id.toString())),

  OPERATIONS_SHELF_LIFE_PAGE: urljoin(ROUTE_PATHS.OPERATIONS_SHELF_LIFE_PAGE),
  OPERATIONS_SHELF_LIFE_DETAIL_PAGE: (id: string | number) =>
    urljoin(ROUTE_PATHS.OPERATIONS_SHELF_LIFE_DETAIL_PAGE(id.toString())),

  OPERATIONS_TRANSFER_INVENTORY_PAGE: urljoin(
    ROUTE_PATHS.OPERATIONS_TRANSFER_INVENTORY_PAGE,
  ),
  OPERATIONS_TRANSFER_INVENTORY_DETAIL_PAGE: (id: string | number) =>
    urljoin(
      ROUTE_PATHS.OPERATIONS_TRANSFER_INVENTORY_DETAIL_PAGE(id.toString()),
    ),

  OPERATIONS_CONVERSION_PAGE: urljoin(ROUTE_PATHS.OPERATIONS_CONVERSION_PAGE),
  OPERATIONS_CONVERSION_DETAIL_PAGE: (id: string | number) =>
    urljoin(ROUTE_PATHS.OPERATIONS_CONVERSION_DETAIL_PAGE(id.toString())),

  LABEL_TEMPLATES_PAGE: urljoin(ROUTE_PATHS.LABEL_TEMPLATES_PAGE),
  MANAGE_OCR_TESTER_PAGE: urljoin(ROUTE_PATHS.MANAGE_OCR_TESTER_PAGE),

  // Task Process
  MANAGE_TASK_PROCESS_PAGE: urljoin(ROUTE_PATHS.MANAGE_TASK_PROCESS_PAGE),

  // Label Printing
  MANAGE_LABEL_PRINTING_PAGE: urljoin(ROUTE_PATHS.MANAGE_LABEL_PRINTING_PAGE),
};
